import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  title: {
    color: '#5F6062',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  label: {
    color: '#6F6F6F',
    fontSize: '14px',

    '& span': {
      fontWeight: 'bold'
    }
  },
  value: {
    color: '#000000',
    opacity: 0.6,
    fontSize: '14px',
    width: '25%',
    textAlign: 'left'
  },
  groupingValue: {
    wordBreak: 'break-all'
  },
  mt20: {
    marginTop: '20px'
  },
  mt30: {
    marginTop: '30px'
  },
  row: {
    display: 'flex',
    marginTop: '30px',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}))

export { useStyles }